import { render, staticRenderFns } from "./InventoryInwardDetails.vue?vue&type=template&id=14d15066"
import script from "./InventoryInwardDetails.vue?vue&type=script&lang=ts"
export * from "./InventoryInwardDetails.vue?vue&type=script&lang=ts"
import style0 from "./InventoryInwardDetails.vue?vue&type=style&index=0&id=14d15066&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sandeep/Work/EIOSYS/CONA-CRM/Admin/Cona-Electrical-Admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14d15066')) {
      api.createRecord('14d15066', component.options)
    } else {
      api.reload('14d15066', component.options)
    }
    module.hot.accept("./InventoryInwardDetails.vue?vue&type=template&id=14d15066", function () {
      api.rerender('14d15066', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/inventory-inwards/components/InventoryInwardDetails.vue"
export default component.exports